import { AccountFragment, UserType } from 'src/graphql'
import {
  useCallback,
  useEffect,
  useMutations,
  usePersistedUserData,
  useQueryParams,
  useVertical,
} from '.'
import useRedirectUriBuilder from './useRedirectUriBuilder'

const useRedirectEffect = () => {
  const { account } = usePersistedUserData()
  const mutations = useMutations()
  const vertical = useVertical()
  const queryParams = useQueryParams()
  const isJoiningAffiliate = queryParams.isJoiningAffiliate
  const redirectUriBuilder = useRedirectUriBuilder()
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const doesNotRequireRedirectUrl = queryParams.client === 'promptingu'

  const redirect = useCallback(
    async (account: AccountFragment) => {
      const {
        createUserLoginLink: { link },
      } = await mutations.createUserLoginLink({
        verticalId: vertical.graphqlVerticalID,
        queryParams,
      })

      const redirectUri = link || redirectUriBuilder(account)
      if (redirectUri) {
        window.location.href = redirectUri
      }
    },
    [mutations, vertical.graphqlVerticalID, queryParams, redirectUriBuilder],
  )

  useEffect(() => {
    if (
      account &&
      (queryParams.redirect_uri || doesNotRequireRedirectUrl) &&
      (!isJoiningAffiliate || account.type === UserType.GSA)
    ) {
      redirect(account)
    }
  }, [
    account,
    queryParams,
    redirect,
    isJoiningAffiliate,
    doesNotRequireRedirectUrl,
  ])
}

export default useRedirectEffect
